import React from "react";
import { useApp } from "@/context/AppContext";
import { Sparkles, Gift, Cake, Users, Star } from "lucide-react";
import { Link } from "react-router-dom";

const PERKS = [
  { icon: Star, title: "Earn Points", body: "Get 1 point per $1 spent + bonus rewards." },
  { icon: Gift, title: "Promotions", body: "Member-only discounts on sensory & safety items." },
  { icon: Cake, title: "Birthday Reward", body: "Special gift for your child each year." },
  { icon: Users, title: "Family Perks", body: "Free ID cards, priority support, early access." },
  { icon: Sparkles, title: "Referral Bonus", body: "100 points per friend who joins." },
];

export default function Membership() {
  const { user } = useApp();
  return (
    <div className="max-w-5xl mx-auto px-6 py-10" data-testid="membership-page">
      <div className="text-center">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">Zi Zi's World Membership</h1>
        <p className="text-slate-600 mt-2">Free to join. Built to support autism families long-term.</p>
      </div>
      {user ? (
        <div className="card-soft p-6 mt-6 text-center">
          <p className="text-sm text-slate-500">Hi {user.name}, your balance:</p>
          <div data-testid="member-points" className="font-display text-5xl font-bold text-pink-600 mt-1">{user.points} pts</div>
          <Link to="/shop" className="btn-pink mt-4 inline-block">Redeem in Shop</Link>
        </div>
      ) : (
        <div className="card-soft p-6 mt-6 text-center">
          <Link to="/login" className="btn-pink" data-testid="member-signin">Sign in to join</Link>
        </div>
      )}
      <div className="grid md:grid-cols-3 gap-4 mt-8">
        {PERKS.map((p) => (
          <div key={p.title} className="card-soft p-5">
            <p.icon className="h-6 w-6 text-pink-500" />
            <h3 className="font-display font-bold mt-2">{p.title}</h3>
            <p className="text-sm text-slate-600 mt-1">{p.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
